module.exports = __webpack_public_path__ + "static/06-nuclear-power-energy 1-da2c77fd2d701c1bc28fdcd8cd2217a1.svg";